require('url-polyfill');

window.ImageRsz_HASH = function(hash) {
	if(typeof hash =='string' && hash.match(/^[0-9a-z]{15}$/i,hash))
		return hash;
	else
		return 'legacy';
}
window.ImageRsz_MODE = function(mode) {
	if(mode==='coi' || mode==='crop')
		return 'crop';
	else
		return 'ratio';
}
window.ImageRsz_COI = function(coi)
{
	if(typeof coi =='string' && coi.match(/,/)!==false)
	{
		var _coi = coi.split(',');
		coi = [_coi[0] || 50, _coi[1] || 50];
		// round COI to the nearest 10%
		coi[0] = Math.round(coi[0]/10) * 10;
		coi[1] = Math.round(coi[1]/10) * 10;
	}
	else
	{
		coi = [50,50];
	}
	return coi.join(',');
}
window.ImageRsz_SizeBreakpoint = function(s)
{
	return parseInt(s);
	/*
	var b = [0, 16, 96, 240, 480, 960, 1200, 1600];
	for(var i=0; i<b.length; i++)
	{
		var c = b[i];
		if(s <= c)
	      break;
	}
	return c;
	*/
}

function isInViewport(element) {
  if(IMAGE_LAZY_MODE && IMAGE_LAZY_MODE=='none')
  	return true;

  var rect = element.getBoundingClientRect();
  var html = document.documentElement;
  //console.debug(rect);
  return (
  	true
    && rect.bottom >= -900
    && rect.top <= (window.innerHeight || html.clientHeight) + 1200
    //&& rect.left >= 0 &&
    //&& rect.right <= (window.innerWidth || html.clientWidth)
  );
}

var app = {
	reset:true,
	resizeCheck:false,
	dynamicCheck:0,
	apply: function(){
		// en cas de resize on met à jour les référence de BG et on relance l'analyse
		if(app.resizeCheck)
		{
			app.resizeCheck = false;
			$('[data-background-image-original]').each(app.check_background);
			app.dynamicCheck = 0;
		}
		// si on est en mode dynamic check (normalement plus rien à traiter on travail au ralenti)
		if(app.dynamicCheck>0)
		{
			//console.log({dynamicCheck:app.dynamicCheck})
			app.dynamicCheck--;
			return;
		}
		// ici on va traiter réellement les visuels à différer
		var srcs = $('img[data-lazy-src]');
		var backgrounds = $('[data-background-image]');
		if(srcs.length==0 && backgrounds.length==0)
		{
			app.dynamicCheck = 10;
			return;
		}
		srcs.each(app.build_image);
		backgrounds.each(app.build_background);
	},
	extract_sizes: function(el,image_hd_url,debug)
	{
		var url = new URL(image_hd_url);
		var containerID = url.searchParams.get("container");

		var W = $(el).outerWidth();
		var H = $(el).outerHeight();

		if(containerID)
		{
			containerID = `|${containerID}|`;

			// variante Desktop et Mobile des application de conteneur
			var containerID_Desktop = containerID.match(/\|d:/) ? containerID.replace(/^.*\|d:([^|]+)(\|.*)?$/,'$1') : false;
			var containerID_Mobile = containerID.match(/\|m:/) ? containerID.replace(/^.*\|m:([^|]+)(\|.*)?$/,'$1') : false;

			if(containerID_Desktop && $(window).outerWidth()>980)
				containerID = containerID_Desktop;
			else if(containerID_Mobile && $(window).outerWidth()<981)
				containerID = containerID_Mobile;
			else if(containerID_Desktop || containerID_Mobile)
				containerID = false

			if(containerID)
			{
				W = $('#'+containerID).outerWidth();
				H = $('#'+containerID).outerHeight();
			}
		}
		//console.log({el,image_hd_url,containerID,W,H});

		return {w:W,h:H};
	},
	reset_background: function(size=null)
	{
		var image_hd_url = $(this).data('backgroundImageOriginal');
		if(image_hd_url)
		{
			if(!size)
			{
				size = app.extract_sizes(this,image_hd_url)
				//console.log(this,size);
			}
			$(this).attr('data-background-image-size',JSON.stringify(size))

			$(this).attr('data-background-image',image_hd_url);
			$(this).removeAttr('data-background-image-original')

			var interval =$(this).data('backgroundImageInterval')
			var my_image = $(this).data('backgroundImageLoader')

			if(my_image)
			{
				$(this).data('backgroundImageLoader',null)
				my_image.setAttribute("src",""); // stop current image load
				my_image.onload = function() {};
				if(interval)
					clearInterval(interval); // prevent onLoad interval call from past processing
			}
		}
	},
	check_background: function()
	{
		var image_hd_url = $(this).data('backgroundImageOriginal');
		var _size = $(this).data('backgroundImageSize');
		_size = typeof _size == 'string' ? JSON.parse(_size) : _size;
		if(image_hd_url && _size)
		{
			var size = app.extract_sizes(this,image_hd_url)
			if(
				size.w > _size.w && size.h >= _size.h
				||
				size.w >= _size.w && size.h > _size.h
			)
			{
				(app.reset_background.bind(this))(size)
			}
		}

	},
	build_background: function()
	{
		var $this = $(this);
		var el = $this[0];
		if(isInViewport(el) && $this.is(':visible'))
		{
			var image_hd_url = $this.data('backgroundImage');
			if(image_hd_url)
			{
				var optimized_url = image_hd_url;
				var url = new URL(image_hd_url);
				var opti = url.searchParams.get("opti");
				var fixed = $this.attr('background-attachment')=="fixed";
				var cropmode = '';

				var size = app.extract_sizes(this,image_hd_url)
				var W = size.w;
				var H = size.h;



				if(opti!==null && opti==0 || fixed)
				{
					// nothing to do
				}
				else
				{
					//console.log("build_background.2",{W,H,image_hd_url,cropmode})
					var optimized = app.processDimension(W,H,image_hd_url,cropmode);
					//console.log("build_background.3",{optimized})
					var optimized_url = optimized ? optimized.url : false;
				}

				if(optimized_url !== false && optimized_url.length > 0)
				{
					//console.log(this,optimized_url);
					var interval =$this.data('backgroundImageInterval')
					var my_image = $this.data('backgroundImageLoader')

					if(my_image && optimized_url.match(/d6808ec-a014-4abe-b773-d514f88fd4bd/))
						console.log(my_image.src,optimized_url);

					if(my_image)
					{
						if(my_image.src===optimized_url)
							return ;
						//console.log('cancel');
						my_image.setAttribute("src",""); // stop current image load
						clearInterval(interval); // prevent onLoad interval call from past processing
					}
					else
					{
						my_image = new Image();
						my_image.onload = function(my_image){
							//console.log('this',this);
							//console.log('my_image',my_image.src);
							var $this = $(this);
							//console.log(this,my_image);
							var node_ratio = $this.outerWidth()/$this.outerHeight();
							var img_ratio = my_image.width/my_image.height;
							//console.log(this,node_ratio,img_ratio);
							if(node_ratio>img_ratio)
								$this.addClass("coverW");
							else
								$this.addClass("coverH");

							// background application
							$this.css({'background-image':'url("'+my_image.src+'")'});

							// interval to fix some weird  issue on animated element
							var interval = setInterval(function(my_image){
								var $this = $(this);
								if($this.css('background-image')!=='url("'+my_image.src+'")')
								{
									$this.css({'background-image':'url("'+my_image.src+'")'});
									clearInterval(interval);
								}
							}.bind(this,my_image),500);
							$this.data('backgroundImageInterval',interval);
						}.bind(this,my_image)
						$this.data('backgroundImageLoader',my_image)
					}

					my_image.src = optimized_url;

					// final cleanup
					$this.attr('data-background-image-original',image_hd_url);
					$this.removeAttr('data-background-image');
					$this.attr('data-background-image-size',JSON.stringify(size));
				}
			}
		}
	},
	build_image: function() // this = dom slider element
	{
		var el = $(this)[0];
		if(isInViewport(el))
		{
			var image_hd_url = $(this).data('lazySrc');
			var W = $(this).width();
			var H = $(this).height();

			var optimized = app.processDimension(W,H,image_hd_url,'');

			if(optimized && optimized.url.length > 0)
			{
				var my_image = new Image();
				my_image.onload = function(){
					$(this).attr('src',my_image.src);
					$(this).css({filter:'blur(0)'});//,'image-rendering':'-webkit-optimize-contrast'});
				}.bind(this)
				my_image.src = optimized.url;
				$(this).removeAttr('data-lazy-src');
			}
			setTimeout(function(){
				$(this).css({filter:'blur(0)'})
			}.bind(this),500);
		}
	},

	processDimension : function(W,H,image_hd_url,cropmode)
	{
		if(image_hd_url.match(/api\.hapidam\.com\/share\/[^?]+\?/))
		{
			return app.processDimension_Hapidam(W,H,image_hd_url,cropmode);
		}
		else
		{
			return app.processDimension_Local(W,H,image_hd_url,cropmode);
		}
	},

	processDimension_Local : function(W,H,image_hd_url,cropmode)
	{
		var result = image_hd_url;

		if(W>0 && H>0)
		{
			var _W = ImageRsz_SizeBreakpoint(W)
			var _H = ImageRsz_SizeBreakpoint(H)

			if(image_hd_url.match(/\/(media|hapidam|instagram)\//))
			{
				var url = new URL(image_hd_url);
				/*
				var w = url.searchParams.get("w");
				var h = url.searchParams.get("h");
				var s = url.searchParams.get("s");
				*/
				var coi = url.searchParams.get("coi");
				var mode = url.searchParams.get("mode");
				var hash = url.searchParams.get("hash");

				hash = ImageRsz_HASH(hash)
				mode = ImageRsz_MODE(mode)
				coi = ImageRsz_COI(coi);

				result = url.origin+url.pathname+'?w='+_W+'&h='+_H+'&coi='+coi+'&mode='+mode+'&hash='+hash;
			}

			return {
				url:result,
				W:_W,
				H:_H,
				coi:coi,
			};
		}
		return false;
	},

	processDimension_Hapidam : function(W,H,image_hd_url,cropmode)
	{
		var result = image_hd_url;

		if(W>0 && H>0)
		{
			var _W = ImageRsz_SizeBreakpoint(W)
			var _H = ImageRsz_SizeBreakpoint(H)

			var url = new URL(image_hd_url);
			/*
			var w = url.searchParams.get("w");
			var h = url.searchParams.get("h");
			*/
			var coi = url.searchParams.get("coi");
			var mode = url.searchParams.get("mode");

			mode = ImageRsz_MODE(mode)
			coi = ImageRsz_COI(coi);

			result = url.origin+url.pathname+'?mode='+mode+'&w='+_W+'&h='+_H+'&coi='+coi;

			return {
				url:result,
				W:_W,
				H:_H,
				coi:coi,
			};
		}
		return false;
	},
}

var resizedelay = null;

$(document).ready(function() {
	var delay = IMAGE_LAZY_MODE && IMAGE_LAZY_MODE=='none' ? 250:500;
	setTimeout(function(){ app.apply(); setInterval(app.apply,100); }, delay);

	var scrolldelay = null;
	$(window).on('scroll',function(){
		clearTimeout(scrolldelay);
		scrolldelay = setTimeout(app.apply,10);
	});
	resizedelay = null;
	$(window).on('resize',function(){
		clearTimeout(resizedelay);
		app.resizeCheck = true;
		resizedelay = setTimeout(app.apply,10);
	});
});

window.hapiLazy = app
window.hapiLazy_build_image = app.build_image
window.hapiLazy_build_background = app.build_background
window.hapiLazy_check_background = app.check_background
window.hapiLazy_reset_background = app.reset_background
window.hapiLazy_extract_sizes = app.extract_sizes

